export const SET_LOCALE = 'SET_LOCALE'

export const SET_MEETING_SLOTS = 'SET_MEETING_SLOTS'
export const SET_SELECTED_MEETING_TYPE = 'SET_SELECTED_MEETING_TYPE'
export const SET_SELECTED_MEETING_TYPE_ID = 'SET_SELECTED_MEETING_TYPE_ID'
export const SET_MEETING_QUESTIONS = 'SET_MEETING_QUESTIONS'
export const SET_MEETING_CALENDARS = 'SET_MEETING_CALENDARS'
export const SET_CREATED_MEETING = 'SET_CREATED_MEETING'
